import { useQuery } from 'react-query';
import * as publicVodApi from '../../api/public/vod';
import { axiosQueryWrapper } from '../utils/axios-wrapper';

export const PUBLIC_VOD_KEYS = {
	fetchVods: ({ channelId, folderId, ignoreFolders }) => ['api', 'channel', 'public', 'vods', 'list', { channelId, folderId, ignoreFolders }].filter((el) => !!el),
	fetchFeturedVods: ({ channelId }) => ['api', 'channel', 'public', 'vods', 'list', 'featured', { channelId }].filter((el) => !!el),
};

export const useFetchPublicVods = (channelId, ignoreFolders = true, folderId) => useQuery(
	PUBLIC_VOD_KEYS.fetchVods({ channelId, folderId, ignoreFolders }),
	axiosQueryWrapper(publicVodApi.fetchAllVodByChannelId, channelId, ignoreFolders, folderId),
	{ enabled: !!channelId },
);

export const useFetchPublicFeaturedVods = (channelId) => useQuery(
	PUBLIC_VOD_KEYS.fetchFeturedVods({ channelId }),
	axiosQueryWrapper(publicVodApi.fetchAllFeaturedVodsByChannelId, channelId),
	{ enabled: !!channelId },
);
